import jaJP from 'antd/locale/ja_JP';
import type { CustomLocale } from '../types/antd';

const custom: CustomLocale = {
  CopyButton: {
    label: 'コピー',
    successText: 'コピーしました。',
    failedText: 'コピーに失敗しました。',
  },
  ToggleButton: {
    activeText: '有効',
    inactiveText: '無効',
  },
};

export default {
  ...jaJP,
  custom,
};
